import React from "react";

function Nftpurchasepop() {
  return (
    <>
      <section className="nft-popup">
        <div className="row">
          <div className="col-lg-12">
            <h1>Your Purchase is processing...</h1>
          </div>
          <div className="col-lg-12 loader-img">
            <img src={require("../Assets/img/loader.png")} alt="" />
          </div>
          <div className="col-lg-12 pop-des">
            <p>
              Your Purchase of ALPHA PASS is processing. It should be confirmed
              on the blockchain shortly.
            </p>
          </div>
          <div className="col-lg-12 transaction-detail">
            <h3>Transaction ID</h3>
            <p>0xf3ce....69c0</p>
          </div>
        </div>
      </section>
    </>
  );
}
export default Nftpurchasepop;
